import { Action, Location } from 'history';

const STORAGE_KEY = 'navigation-stack';

type EntryKey = string | null;

interface PersistedState {
  stack: EntryKey[];
  index: number;
}

let stack: EntryKey[] = [null];
let index = 0;

const toEntryKey = (key?: string): EntryKey => key || null;

const persist = () => {
  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ stack, index })
    );
  } catch {}
};

const readPersisted = (): PersistedState | null => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as PersistedState;

    if (!Array.isArray(parsed?.stack) || typeof parsed?.index !== 'number') {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const initNavigationDepth = (currentKey?: string) => {
  const key = toEntryKey(currentKey);
  const persisted = key ? readPersisted() : null;
  const persistedIndex = persisted ? persisted.stack.indexOf(key) : -1;

  if (persisted && persistedIndex >= 0) {
    stack = persisted.stack;
    index = persistedIndex;
    persist();
    return;
  }

  stack = [key];
  index = 0;
  persist();
};

export const recordNavigation = (action: Action, location: Location) => {
  const key = toEntryKey(location.key);

  if (action === 'PUSH') {
    stack = stack.slice(0, index + 1).concat(key);
    index = stack.length - 1;
  } else if (action === 'REPLACE') {
    stack[index] = key;
  } else {
    const foundIndex = stack.indexOf(key);
    index = foundIndex >= 0 ? foundIndex : 0;
  }

  persist();
};

export const canGoBackInApp = () => index > 0;
